// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1WebhookSchema = z.object({
  id: z.number().int().describe("Unique identifier for the webhook"),
  account_id: z.number().int().describe("Account ID the webhook belongs to"),
  url: z.coerce.string().describe("URL to send webhook payloads to (must be HTTPS)"),
  subscriptions: z.array(z.enum(["forecasts:created", "forecasts:updated", "forecasts:deleted", "hours:created", "hours:updated", "hours:deleted", "labels:created", "labels:updated", "labels:deleted", "projects:created", "projects:updated", "projects:deleted"])).describe("List of event types to subscribe to"),
  secret_token: z.coerce.string().describe("Secret token used to sign webhook payloads for verification").nullish(),
  active: z.boolean().describe("Whether the webhook is active and will receive events"),
  custom_headers: z.object({}).describe("Custom HTTP headers to include in webhook requests"),
  created_at: z.string().datetime().describe("ISO8601 timestamp of when the webhook was created"),
  updated_at: z.string().datetime().describe("ISO8601 timestamp of when the webhook was last updated"),
});
